import {
  FormControl,
  IconButton,
  TextField,
  Typography,
  InputAdornment,
  Box,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import React, { useState } from "react";
import styles from "./styles";
import { FieldMetaState, FieldRenderProps } from "react-final-form";

export interface IOwnProps {
  input?: any;
  meta: FieldMetaState<string>;
  label?: string;
  required?: boolean;
  type?: string;
  size?: number;
  disabled?: boolean;
  note?: string;
}

const InputPassword: React.FC<
  IOwnProps & FieldRenderProps<any, HTMLElement, any>
> = ({
  input,
  meta: { error, touched },
  label,
  required = false,
  size,
  disabled = false,
  note,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const val = event.target.value;
    if (input) {
      input.onChange(val);
    }
  };

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Box sx={styles}>
      <div>
        <FormControl className={"root"}>
          <TextField
            {...input}
            disabled={disabled}
            label={label}
            error={touched && !!error}
            required={required}
            className={"textFieldRoot"}
            InputProps={{
              classes: {
                input: "textField inputPassword",
                underline: "underline",
              },
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    className={"showPassword"}
                    onClick={handleTogglePassword}
                    aria-label={
                      showPassword
                        ? "Masquer le mot de passe"
                        : "Afficher le mot de passe"
                    }
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            inputProps={{ size }}
            onChange={handleChange}
            InputLabelProps={{
              classes: {
                root: "textFieldLabel",
                focused: "textFieldLabelFocused",
                error: "textFieldLabelError",
                asterisk: "textFieldLabelAsterisk",
              },
            }}
            variant="filled"
            type={showPassword ? "text" : "password"}
          />
        </FormControl>
      </div>
      {note && (
        <div>
          <Typography className={"caption"} variant="caption">
            {note}
          </Typography>
        </div>
      )}
      {error && touched && (
        <div style={{ maxWidth: 300 }}>
          <Typography color="error" variant="caption">
            {error}
          </Typography>
        </div>
      )}
    </Box>
  );
};

export default InputPassword;
